import { render, staticRenderFns } from "./tAlert.vue?vue&type=template&id=43ada0ab&"
import script from "./tAlert.vue?vue&type=script&lang=js&"
export * from "./tAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports